/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Reingest_Approval_ApprovedInputs */

const es_components_reingest_approval_approved = /** @type {(inputs: Components_Reingest_Approval_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Re-ingesta aprobada`)
};

const en_components_reingest_approval_approved = /** @type {(inputs: Components_Reingest_Approval_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Re-ingestion approved`)
};

/**
* | output |
* | --- |
* | "Re-ingestion approved" |
*
* @param {Components_Reingest_Approval_ApprovedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_reingest_approval_approved = /** @type {((inputs?: Components_Reingest_Approval_ApprovedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Reingest_Approval_ApprovedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_reingest_approval_approved(inputs)
	return en_components_reingest_approval_approved(inputs)
});
export { components_reingest_approval_approved as "components.reingest_approval.approved" }